import { RateType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import * as yup from 'yup';

import { toDecimal } from '~utils/decimal';

export const isLegacyCommissionRateType = (rateType: string | null | undefined) =>
  rateType === RateType.RATE_COMMISSION || rateType === RateType.RATE_FLAT_COMMISSION;

export function isValidCommissionPercentage(value: string) {
  return (
    /^\d+(\.\d{1,4})?$/.test(value) &&
    toDecimal(value).greaterThanOrEqualTo(0) &&
    toDecimal(value).lessThanOrEqualTo(100)
  );
}

export const commissionPercentageSchema = yup
  .string()
  .nullable()
  .notRequired()
  .test(
    'commission-percentage',
    t('pay_commission.percentage_invalid'),
    (value) =>
      value === undefined || value === null || isValidCommissionPercentage(value),
  );
